// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2wJ98c5-Ix101pYtZnAfbS{display:flex;margin-left:-1.6rem;margin-right:-1.6rem;max-width:calc(60vw + 7.2rem);overflow-x:auto;padding:.3rem 1.6rem}._2wJ98c5-Ix101pYtZnAfbS::-webkit-scrollbar{display:none}._1oT7H11gnHItqOFE0jKe3-._1oT7H11gnHItqOFE0jKe3-{flex-shrink:0;margin-right:2rem;width:60vw}@media (min-width:480px){._2wJ98c5-Ix101pYtZnAfbS{box-shadow:none;flex-wrap:wrap;margin:0;max-width:100%;padding:0}._1oT7H11gnHItqOFE0jKe3-._1oT7H11gnHItqOFE0jKe3-{width:calc(33.33333% - 1.33333rem)}._1oT7H11gnHItqOFE0jKe3-:nth-child(3n+0){margin:0}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "_2wJ98c5-Ix101pYtZnAfbS",
	"characteristicBox": "_1oT7H11gnHItqOFE0jKe3-"
};
module.exports = ___CSS_LOADER_EXPORT___;
